import ApiService from './ApiService';

class TasksService {
  static async createTask(payload) {
    const composedURL = `/api3/schedule/calendar_task/`;
    const response = await ApiService.post(composedURL, payload);
    return response;
  }

  static async getRightbarTasks() {
    const composedURL = `/api3/schedule/calendar_task/rightbar/`;
    const response = await ApiService.get(composedURL);

    return response;
  }

  static async editTask({ id, payload }) {
    const composedURL = `/api3/schedule/calendar_task/${id}/`;
    const response = await ApiService.patch(composedURL, payload);
    return response;
  }

  static async getPaginatedTasks(query) {
    let composedURL = `/api3/schedule/calendar_task/task_list/`;

    if (query) {
      composedURL += query;
    }

    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getAgentConflicts(query) {
    let composedURL = `/api3/schedule/calendar_task/agent_conflicts/`;

    if (query) {
      composedURL += query;
    }

    const response = await ApiService.get(composedURL);
    return response;
  }
}

export default TasksService;
